module.exports = __webpack_public_path__ + "img/BRCA1_Fibroblasts.8aa1c06f.png";